/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Column } from '../models/Column';
import type { DatasetPayload } from '../models/DatasetPayload';
import type { EmailScheduleAttributes } from '../models/EmailScheduleAttributes';
import type { QueuedDatasetWebhookPayload } from '../models/QueuedDatasetWebhookPayload';
import type { QueuedTodaysPropertyReportEmailsBody } from '../models/QueuedTodaysPropertyReportEmailsBody';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InternalService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any Ok
     * @throws ApiError
     */
    public postUsageRecord(): CancelablePromise<{
        data: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/customer/usage',
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public postAuth0(
        requestBody: any,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/auth0',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public auth0CurrentSubscription(
        requestBody: {
            user_id: string;
        },
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/current_subscription',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public fillBulkDataQueue(): CancelablePromise<{
        failed: number;
        succeeded: number;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/queue_bulk_data_emails',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public fillDatasetQueue(): CancelablePromise<{
        failed: number;
        succeeded: number;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/queue_emails',
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public sendPropertyReportEmail(
        requestBody: QueuedTodaysPropertyReportEmailsBody,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/send_property_report_email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Process queued dataset export and notify webhook when complete.
     *
     * This internal endpoint is called by Google Cloud Tasks to process dataset
     * export jobs that were queued by the public API. It performs the actual
     * data export and then notifies the user's webhook with the results.
     *
     * ## Processing Workflow:
     * 1. Validates the webhook URL (security check)
     * 2. Exports the dataset to Google Cloud Storage
     * 3. Calls the user's webhook with export results
     * 4. Returns success/failure status
     *
     * ## Security:
     * - Only accessible via internal API key authentication
     * - Re-validates webhook URLs to prevent SSRF attacks
     * - Uses the same validation as the public API
     *
     * ## Error Handling:
     * - 400: Invalid webhook URL
     * - 500: Export failed or webhook delivery failed
     * - Errors are logged for debugging
     * @param requestBody - Queued webhook payload with export configuration
     * @returns any 200 with success message, or error response
     * @throws ApiError
     */
    public notifyDatasetWebhook(
        requestBody: QueuedDatasetWebhookPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/dataset_webhook',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public sendDatasetEmailDetailed(
        requestBody: {
            userId: string;
            email_schedule?: EmailScheduleAttributes;
            format: 'csv' | 'jsonl';
            name: string;
            emails: Array<string>;
            payload: DatasetPayload;
            queryUUID: string;
        },
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/send_dataset_email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public remindInvites(): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/send_invitation_reminders',
        });
    }
    /**
     * @param col
     * @returns any Ok
     * @throws ApiError
     */
    public healthCheck(
        col?: Column,
    ): CancelablePromise<{
        col?: Column;
        data: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/health',
            query: {
                'col': col,
            },
        });
    }
}
